import React, { useEffect, useState } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { Dashboard } from './apps/Dashboard';
import { CardsIndex as Cards } from './apps/Cards';
import { Quizzes } from './apps/Quizzes';
import { HomeWork } from './apps/HomeWork';
import { WpPage } from './apps/WpPage';
import { PopupPlan } from './components/PopupPlan';
import { PopupMembership } from './components/PopupMembership';
import { AppContextProvider } from './AppContext';
import { PioSolver } from './apps/PioSolver/PioSolver';
import { ICMCharts } from './apps/ICMCharts';
import { PreflopCharts } from './apps/PreflopCharts';
import { LiveEvents } from './apps/LiveEvents/LiveEvents';
import { PrivateCoaching } from './apps/PrivateCoaching/PrivateCoaching';
import ClearTheChartsContainer from './apps/ClearTheCharts/ClearTheChartsContainer';
import QuizAssessment from './apps/Dashboard/components/QuizAssessment';
import Peak from './apps/Peak/Peak';

function highlightMenuItem(pathname) {
  const rootPath = pathname.slice(0, pathname.indexOf('/', 1) + 1);
  const activeClasses = ['current-menu-item', 'current_page_item'];

  document
    .querySelector('.menu .current-menu-item')
    ?.classList.remove(...activeClasses);
  document
    .querySelector(`.menu li a[data-path="${rootPath}"]`)
    ?.closest('.menu-item')
    .classList.add(...activeClasses);
}

export function App({ onlyPlanPopup = false }) {
  const [isShowPopupPlan, setIsShowPopupPlan] = useState(false);
  const [popupPlan, setPopupPlan] = useState(null);
  const [isShowPopupMembership, setIsShowPopupMembership] = useState(false);
  const [popupMembership, setPopupMembership] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const { pathname, search } = useLocation();

  useEffect(() => {
    setPrevUrl(window.location.href);

    function handleShowPopupPlan(e) {
      setIsShowPopupPlan(true);
      setPopupPlan(e.detail);
    }

    function handleShowPopupMembership(e) {
      setIsShowPopupMembership(true);
      setPopupMembership(e.detail);
    }

    document.addEventListener('showPopupPlan', handleShowPopupPlan);
    document.addEventListener('showPopupMembership', handleShowPopupMembership);

    return () => {
      document.removeEventListener('showPopupPlan', handleShowPopupPlan);
      document.removeEventListener(
        'showPopupMembership',
        handleShowPopupMembership
      );
    };
  }, []);

  useEffect(() => {
    highlightMenuItem(pathname);
  }, [pathname]);

  useEffect(() => {
    const url = window.location.href;

    setTimeout(() => {
      const { referrer, title } = document;

      window.analytics?.page({
        path: pathname,
        referrer: !!prevUrl ? prevUrl : referrer,
        search,
        title,
        url,
      });
    }, 2000);

    setPrevUrl(url);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, search]);

  function closePopupPlan() {
    setIsShowPopupPlan(false);
    setPopupPlan(null);
  }

  function closePopupMembership() {
    setIsShowPopupMembership(false);
    setPopupMembership(null);
  }

  return (
    <>
      {!onlyPlanPopup && (
        <AppContextProvider>
          <Switch>
            <Route path="/dashboard/" key="dashboard">
              <Dashboard />
            </Route>
            <Route path="/classes/" key="classes">
              <Cards basePath="/classes/" type="classes" />
            </Route>
            <Route path="/courses/" key="courses">
              <Cards basePath="/courses/" type="courses" />
            </Route>
            <Route path="/legacy-courses/" key="legacy-courses">
              <Cards basePath="/legacy-courses/" type="courses" isLegacy={true} />
            </Route>
            <Route path="/challenges/" key="challenges">
              <Cards basePath="/challenges/" type="challenges" />
            </Route>
            <Route path="/quizzes/" key="quizzes">
              <Quizzes />
            </Route>
            <Route path="/homework/" key="homework">
              <HomeWork />
            </Route>
            <Route path="/piosolver-starter-pack/" key="piosolver">
              <PioSolver />
            </Route>
            <Route path="/privatecoaching/" key="privatecoaching">
              <PrivateCoaching />
            </Route>
            <Route path="/charts/icm/" key="icmcharts">
              <ICMCharts />
            </Route>
            <Route path="/charts/gto/" key="preflopcharts">
              <PreflopCharts />
            </Route>
            <Route path="/peak/" key="peak">
              <Peak />
            </Route>
            <Route path="/live-events/" key="live-events/">
              <LiveEvents />
            </Route>
            <Route path="/clearthecharts/" key="clearthecharts">
              <ClearTheChartsContainer />
            </Route>
            <Route path="/quiz-assessment/" key="quiz-assessment">
              <QuizAssessment />
            </Route>
            <Route path="/:path/" key="wp-page">
              <WpPage />
            </Route>
          </Switch>
        </AppContextProvider>
      )}

      {isShowPopupPlan && popupPlan && (
        <PopupPlan {...popupPlan} closeModal={closePopupPlan} />
      )}

      {isShowPopupMembership && popupMembership && (
        <PopupMembership
          {...popupMembership}
          closeModal={closePopupMembership}
        />
      )}
    </>
  );
}
